import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function CoachModal() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button className="btn-outline-light" variant="danger" size='sm' onClick={handleShow}>
        Info
      </Button>

      <Modal show={show} onHide={handleClose} animation={true} size='lg' aria-labelledby='contained-modal-title-vcenter' centered style={{backgroundColor:'black'}}>
        <Modal.Header style={{backgroundColor:'black', border:"2px solid", borderColor:"#D33D3D"}}>
          <Modal.Title style={{backgroundColor:'black', border:'none', color:'white'}}>Comprehensive Coaching Subscription</Modal.Title>
        </Modal.Header>
        <Modal.Body  style={{backgroundColor:'black', border:"2px solid", borderColor:"#D33D3D", color:'white'}}>
            <h2>
              <u>
                Custom Workout Program
              </u> 
            </h2>
            <p>
              Progressive resistance training tailored to your fitness level, goals, and lifestyle. We build your plan around your personal schedule — including available training days, preferred session duration, equipment access (home or commercial gym), and exercise preferences. Every program is designed to work for you, not against your routine.
            </p>
            <h2>
              <u>
                Personalized Meal Plan
              </u>
            </h2>
            <p>
              Science-based nutrition built around your goals and food preferences. We calculate precise macronutrient targets while accommodating your daily schedule, food availability, and dietary preferences. Whether you’re curious about carnivore, keto, fasting, or just want balanced meals with room for snacks and cheat options — we’ll make it fit your life and your goals.
            </p>
            <h2>
              <u>  
                Weekly Check-Ins
              </u>
            </h2>
            <p>Regular progress reviews with direct feedback and plan adjustments to keep you accountable. You’ll track photos, metrics, and performance data so we can provide objective, measurable proof of your progress throughout the journey.</p>
            <h2>
              <u>
                24/7 Access
              </u>
            </h2>
            <p>Reach your coach anytime for guidance, motivation, or quick answers. We prioritize long-term relationships — supporting you every step of the way with honest communication and professional accountability.</p>
            <h2>
              <u>                
                Educational Resources
              </u>
            </h2>
            <p>Learn the why behind your program. We want you to reach a point where you can confidently sustain your results through the knowledge, habits, and values built during your coaching experience.</p>
            <h2>
              <u>                
                Performance Tools
              </u>
            </h2>
            <h5>Access powerful tools that make tracking easy:</h5>
            <p>Adherence Chart: Monitor your daily consistency and progress.</p>
            <p>Food Diary: Log meals with text or images for quick feedback.</p>
            <p>Calorie Counter: Track every macro and calorie with precision.</p>
            <p>Integrations: Sync seamlessly with MyFitnessPal, Fitbit, and Myzone for a complete performance overview.</p>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor:'black', border:"2px solid", borderColor:"#D33D3D"}}>
          <h5 className='col' style={{color:"white"}}>
            Price: $250.00 / Month
          </h5>
          <Button  variant="danger"  onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CoachModal;